import { ADDRESS_INFO  } from "actions/types";
import { baseStore } from "../common/baseStore"

export default baseStore(ADDRESS_INFO)